import { Search } from "lucide-react-native";
import { IconButton } from "@louise/moon-ui";
import { EMBER } from "../../onboarding/theme";

type Props = {
  onPress?: () => void;
};

export default function SearchButton({ onPress }: Props) {
  return (
    <IconButton
      onPress={onPress}
      hitSlop={8}
      size={36}
      accessibilityLabel="Search"
    >
      <Search size={22} color={EMBER.colors.textMid} strokeWidth={1.5} />
    </IconButton>
  );
}
